import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';
import { extend } from 'jquery';

var tableDom = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

var BONUS_COLUMNS_INDEX = {
    Id: 0,
    Name: 1,
    Currencies: 2,
    Status: 3
};

export interface OperationDetailPageOptions extends PageOptionsBase {
    dataSwitch: string;
    urlList: string;
    urlDetail: string;
    urlPost: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
        DetailsLink: string;
    }
}

export class OperationChannelsPage extends PageBase<OperationDetailPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _tableId: string;

    constructor(options: OperationDetailPageOptions) {
        super(options);
        var getDetailUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.Id}`);

        this.addChannelsMulti = this.addChannelsMulti.bind(this);

        this._tableId = "tableChannels";
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',
            autoWidth: true,
            ordering: false,
            columns: [
                {
                    data: '',
                    render: (data: any, type: any, rowData: any) => {
                        if (rowData.Id === 0) {
                            return `<input id='chckbx${rowData.Channel.Code}' name='selectedChannel' value='${rowData.Channel.Id}' type='checkbox'" />`;
                        }
                        else {
                            return "";
                        }
                    }
                },
                {
                    data: 'Channel.Name',
                    className: "bold",
                    render: (data: any, type: any, rowData: any) => {
                        if (rowData.Id === 0) {
                            return data;
                        }
                        else {
                            return `<a id='lnkName${rowData.Id}' href='${getDetailUrl(rowData)}'>${data}</a>`;
                        }
                    }
                },
                {
                    data: "Channel.Code",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCode${rowData.Id}'>${data}</span>`)
                },
                {
                    data: "IsEnabled",
                    render: (data: any, type: any, rowData: any) => {
                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                        var css = data === true ? 'status-enabled' : 'status-disabled';
                        return `<span id='spnState${rowData.Id}' class='${css}'>${text}</span>`;
                    }
                },
                {
                    data: '',
                    render: (data: any, type: any, rowData: any) => {
                        var assigned = rowData.Id !== 0 ? 'True' : 'False';
                        var css = rowData.Id !== 0 ? 'status-enabled' : 'status-disabled';
                        return `<span id='spnAssigned${rowData.Id}' class='${css}'>${assigned}</span>`;
                    }
                }
            ]
        };
    // === prepare table options
    }

    init(): void {
        const btnAddChannels = Utils.getJQueryById("lnkAddSelectd");
        btnAddChannels.on("click", this.addChannelsMulti);

        // == create 'new Datatable' instance
        if (Utils.isNullOrUndefined(this._tableOptions))
            return;
        this._table = new Datatable(this._tableId, this._tableOptions);
    }

    private addChannelsMulti(e: JQueryEventObject) {
        e.preventDefault();
        var urlPost = this._options.urlPost;
        var table = this._table;
        var ids = $("input[name='selectedChannel']:checked").map(function () {
            return $(this).val();
        });
        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'html',
            data: { channelIds: ids.get() },
            success: function (data) {
                table.draw();
            }
        });
    }
}

export class OperationBonusesPage extends PageBase<OperationDetailPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _tableId: string;

    constructor(options: OperationDetailPageOptions) {
        super(options);
        var getDetailUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.Id}`);

        this.addChannelsMulti = this.addChannelsMulti.bind(this);

        this._tableId = "tableBonuses";
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',
            autoWidth: true,
            lengthMenu: [[10, 20, 100], [10, 20, 100]],
            columns: [
                {
                    data: 'Id'
                },
                {
                    data: 'Name',
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkDetail${rowData.Id}' href='${getDetailUrl(rowData)}'>${data}</a>`)
                },
                {
                    data: 'Currencies',
                    sortable: false
                },
                {
                    data: 'Status'
                },
                {
                    data: 'RelationStatus'
                }
            ],
            order: [[BONUS_COLUMNS_INDEX.Status, "asc"]],
        };
    }

    init(): void {
        const btnAddChannels = Utils.getJQueryById("lnkAddSelected");
        btnAddChannels.on("click", this.addChannelsMulti);

        // == create 'new Datatable' instance
        if (Utils.isNullOrUndefined(this._tableOptions))
            return;
        this._table = new Datatable(this._tableId, this._tableOptions);
    }

    private addChannelsMulti(e: JQueryEventObject) {
        e.preventDefault();
        var urlPost = this._options.urlPost;
        var table = this._table;
        var ids = $("input[name='selectedChannel']:checked").map(function () {
            return $(this).val();
        });
        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'html',
            data: { channelIds: ids.get() },
            success: function (data) {
                table.draw();
            }
        });
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Customers/OperationDetailPage.ts
 **/